import React, { useCallback, useState } from 'react';
import { ContainerIconWrapper as Container } from 'src/pages/Investing/Invests/components/styles';
import { Popup } from 'src/interface/cabinet/header/Dropdown/styles';
import LockBlueIcon from '#app/assets/icons/lock_blue.svg';

/** @param {{ active: import('finhelper').GridActiveModel }} props */
const BlockedPopup = ({ active }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleMouseOver = useCallback(() => setIsOpen(true), []);
  const handleMouseLeave = useCallback(() => setIsOpen(false), []);

  if (!active.is_blocked) return null;

  return (
    <Container onMouseOver={handleMouseOver} onMouseLeave={handleMouseLeave}>
      <img style={{ width: '12px' }} src={LockBlueIcon} alt="" />
      <Popup
        open={isOpen}
        id={'popup-transfer-' + active.id}
        className="asset-popup"
        $position={{ top: '-10px', left: '24px' }}
        width={'300px'}
      >
        <div style={{ padding: '10px 20px', minWidth: 'fit-content' }}>Заблокированный актив</div>
      </Popup>
    </Container>
  );
};

export default BlockedPopup;
